import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { MyLabel, MyLabelId } from '../../reducers/sourcingAnnotationCandidates'
import { useRef, useState } from 'react'
import { OptionDropdown } from '@/components/view/OptionDropdown'
import { OptionDropdownItem } from '@/components/view/OptionDropdownItem'
import { useOnClickOutside } from '@/hooks/useOnClickOutside'

type Props = {
  candidates: MyLabel[]
  selectedMyLabelIds: MyLabelId[]
  onSelect: (id: MyLabelId) => void
}

function selectedMyLabels(
  selectedMyLabelIds: MyLabelId[],
  candidates: MyLabel[]
): string {
  const selectedMyLabels = candidates.filter((item) =>
    selectedMyLabelIds.includes(item.id)
  )
  switch (selectedMyLabels.length) {
    case 0:
      return ''
    case 1:
      return ` = ${selectedMyLabels[0].name}`
    default:
      return ` = ${selectedMyLabels[0].name}, ...`
  }
}

export const MyLabelSearchCondition: React.FC<Props> = ({
  candidates,
  selectedMyLabelIds,
  onSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const cellRef = useRef<HTMLDivElement>(null)
  useOnClickOutside([cellRef], () => {
    if (isOpen) {
      setIsOpen(!isOpen)
    }
  })

  return (
    <div>
      <button
        className="condition-label"
        css={css`
          display: flex;
          max-width: 300px;
          align-items: center;
          background-color: ${colors.cyan50};
          border-radius: 50px;
          color: ${colors.white10};
          font-size: 13px;
          position: relative;
          border: none;
          cursor: pointer;
          outline: none;
          padding: 5px 10px 5px 15px;
        `}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        <span
          css={css`
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          `}
        >
          マイラベル
          {selectedMyLabels(selectedMyLabelIds, candidates)}
        </span>
        <IcomoonIcon
          name="arrow8-down"
          css={css`
            font-size: 10px;
            color: ${colors.white10};
            &:before {
              font-size: 0.65rem;
              margin-left: 5px;
            }
          `}
        />
      </button>
      {isOpen && (
        <div ref={cellRef}>
          <OptionDropdown
            open={isOpen}
            _css={css`
              max-height: 265px;
              overflow-y: auto;
              width: 214px;
            `}
          >
            {candidates.length === 0 ? (
              <li
                css={css`
                  text-align: center;
                  padding: 7px 12px 7px 12px;
                  font-size: 14px;
                  color: ${colors.textLight};
                `}
              >
                まだマイラベルはありません
              </li>
            ) : (
              <>
                {candidates.map((item, i) => (
                  <OptionDropdownItem
                    key={item.id}
                    idx={i}
                    condition={selectedMyLabelIds.includes(item.id)}
                    handleSet={() => onSelect(item.id)}
                    label={item.name}
                    _css={css`
                      max-width: 300px;
                      text-overflow: ellipsis;
                    `}
                  />
                ))}
              </>
            )}
          </OptionDropdown>
        </div>
      )}
    </div>
  )
}
